import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';
import { MdEditNote } from 'react-icons/md';
import MySelect from '../../components/MySelect';

const EditExamen = ({ onClose, selectedExamen }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [classes, setClasses] = useState([]);
    const [selectedClasse, setSelectedClasse] = useState(null);
    const [inputValueClasse, setValueClasse] = useState('');

    const [matieres, setMatieres] = useState([]);
    const [selectedMatiere, setSelectedMatiere] = useState(null);
    const [inputValueMatiere, setValueMatiere] = useState('');

    const [trimestres, setTrimestres] = useState([]);
    const [selectedTrimestre, setSelectedTrimestre] = useState(null);
    const [inputValueTrimestre, setValueTrimestre] = useState('');

    const [enseignants, setEnseignant] = useState([]);
    const [selectedEnseignant, setSelectedEnseignant] = useState(selectedExamen.enseignant);
    const [inputValueEnseignant, setValueEnseignant] = useState('');


    const [examen, setExamen] = useState({
        id: selectedExamen.id,
        classe: '',
        matiere: '',
        heureDebut: selectedExamen.heureDebut,
        heureFin: selectedExamen.heureFin,
        enseignant: selectedExamen.enseignant.id,
        dateExamen: selectedExamen.dateExamen,
        coefficient: selectedExamen.coeff,
        noteMax: selectedExamen.noteMax,
        ordre:selectedExamen.ordre,
    });


    const handleChangeEnseignant = value => {
        setSelectedEnseignant(value);
        setExamen({ ...examen, enseignant: value.id });


    }

    const handleInputChangeEnseignant = value => {
        setValueEnseignant(value);
    };
    // handle selection



    const navigate = useNavigate();




    const getEnseignants = () => {
        axiosClient.get('/enseignants')
            .then((data) => {
                setEnseignant(data.data.enseignants);
            }).catch(err => {
                navigate('/500');
            })
    }



    useEffect(() => {
        setLoading(true);


        getEnseignants();
        setLoading(false);
    }, []);
    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/examen/update', examen)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une Erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }



    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col max-h-screen overflow-y-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-xl'>
                        <div className=''>
                            <Header icon={<MdEditNote />} title="Modifier un examen" titleAr="تحرير إمتحان" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-2'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Date" labelAr="التاريخ" type="date" value={examen.dateExamen} onChange={ev => setExamen({ ...examen, dateExamen: ev.target.value })} required="required" />
                                    </div>
                                    <div className="flex-col w-full">

                                        <Input readOnly="readOnly" label="Classe" labelAr="القسم" type="text" value={selectedExamen.classe.libelle} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <Input label="Coefficient" labelAr="الضارب" type="number" value={examen.coefficient} onChange={ev => setExamen({ ...examen, coefficient: ev.target.value })} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <Input label="Note Max" labelAr="التنقيط" type="number" value={examen.noteMax} onChange={ev => setExamen({ ...examen, noteMax: ev.target.value })} required="required" />
                                    </div>
                                    <div className="flex-col w-full">
                                        <Input label="Ordre" labelAr="الترتيب" type="number" value={examen.ordre} onChange={ev => setExamen({ ...examen, ordre: ev.target.value })} required="required" />
                                    </div>
                                </div>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className="flex-col w-full">
                                        <Input readOnly="readOnly" label="Matiere" labelAr="المادة" type="text" value={selectedExamen.matiere.libelle} required="required" />
                                    </div>
                                    <MySelect label="Enseignant" labelAr="المصحح" placeholder="Enseignant" cacheOptions defaultOptions value={selectedEnseignant} getOptionLabel={e => e.nomTel} getOptionValue={e => e.id} options={enseignants} onInputChange={handleInputChangeEnseignant} onChange={handleChangeEnseignant} />
                                    <div className="flex-col w-full">
                                        <Input readOnly="readOnly" label="Trimestre" type="text" value={selectedExamen.trimestre.code} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Heure Debut" type="time" value={examen.heureDebut} onChange={ev => setExamen({ ...examen, heureDebut: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Heure Fin" type="time" value={examen.heureFin} onChange={ev => setExamen({ ...examen, heureFin: ev.target.value })} required="required" />
                                    </div>
                                </div>
                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />

                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default EditExamen